import { WorkflowRole } from '@exam-management/common/types';
import { WorkflowStepCode } from '@exam-management/graphql';

import { PageHeaderActionVariant } from '../../constants';

const variant: Partial<
  Record<WorkflowRole, Partial<Record<WorkflowStepCode, PageHeaderActionVariant>>>
> = {
  [WorkflowRole.TASK_ASSIGNEE]: {
    [WorkflowStepCode.QuestionCreationInProgress]: PageHeaderActionVariant.FINISH_TASK,
  },
};

export default function getPageHeaderActionVariant(
  roles: { isOwner: boolean; isAssignee: boolean },
  workflowStepCode: WorkflowStepCode,
): keyof typeof PageHeaderActionVariant | null {
  if (roles.isAssignee) {
    return variant[WorkflowRole.TASK_ASSIGNEE]?.[workflowStepCode] ?? null;
  }

  return null;
}
